import { useQuery } from '@tanstack/react-query';

import getLibraryItemInfo from '@/requests/library/getLibraryItemInfo';

/**
 * Read-only preset lookup by slug. Returns `null` on 404 / fetch failure.
 *
 * Separate from `useLibraryItemInfoMutation` because that hook has side
 * effects (sets `selectedPreset`, switches `screen` to Create) — we only
 * want to *check existence* here (e.g. Lightbox "Reuse template" gating).
 * Both share the `['libraryItemInfo', slug]` cache, so a real click later
 * doesn't refetch.
 */
const useLibraryItemQuery = (slug?: string) =>
  useQuery({
    queryKey: ['libraryItemInfo', slug],
    queryFn: () => getLibraryItemInfo(slug ?? ''),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
  });

export default useLibraryItemQuery;
